import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { getSubmitOssFormat, removeExpires, showModal } from '../../components/common/utils'
import ApplicantDetailStatus from '../../components/common/ApplicantDetailStatus'
import { isMember } from '../../reducers/selectors'
import { usePayAfdi, useSubmitAfdi } from '../../services/hooks'
import { useHistory } from 'react-router-dom'

const ApplicationStatus = ({ detail, formData, checkAge, checked, isAutoRenewJump, certComplete, addressComplete }) => {
  const { formatMessage } = useIntl()
  const { push } = useHistory()
  const { runAsync: submitAfdi, loading: submitting } = useSubmitAfdi()
  const { runAsync: toPay } = usePayAfdi()

  const { signatureUrl, ismember } = useSelector((state) => ({
    signatureUrl: state.ui.signatureUrl,
    ismember: isMember(state),
  }))

  const verifyData = () => {
    const {
      languageId,
      regionId,
      teachingCount,
      teachingCountFiles,
      cdinstructorNumber,
      courseLocation,
      finishDate,
      fdi,
      owsi,
      candidateMethod,
      fdifiles,
    } = formData

    const regionStatus = ismember ? true : regionId
    const trainingInfoComplete = fdi || owsi ? true : Boolean(cdinstructorNumber && courseLocation && finishDate)
    const regionAndLangCmplete = Boolean(regionStatus && languageId)
    const teachingComplete = teachingCount || (teachingCountFiles && teachingCountFiles.length > 0)
    // CHNA-2766：选了候选人方法就按方法校验；未选（历史口径）不额外拦截
    const fdiFilesComplete = fdifiles && fdifiles.length > 0
    const candidateReady =
      !candidateMethod ||
      (candidateMethod === 'method1'
        ? (fdi || fdiFilesComplete) && teachingComplete
        : candidateMethod === 'method2'
          ? !fdi && fdiFilesComplete && teachingComplete && Boolean(cdinstructorNumber && courseLocation && finishDate)
          : false)

    return (
      trainingInfoComplete &&
      addressComplete &&
      regionAndLangCmplete &&
      checkAge &&
      checked &&
      signatureUrl &&
      certComplete &&
      teachingComplete &&
      candidateReady
    )
  }

  const submit = () => {
    if (verifyData()) {
      const { finishDate, cdinstructorNumber, code, regionId, fdi, owsi, ...data } = formData
      let submitData = {
        ...data,
        efrfiles: data.efrfiles ? removeExpires(data.efrfiles) : [],
        fdifiles: data.fdifiles ? removeExpires(data.fdifiles) : [],
        teachingCountFiles: data.teachingCountFiles ? removeExpires(data.teachingCountFiles) : [],
        mfdfiles: data.mfdfiles ? removeExpires(data.mfdfiles) : [],
        fdipreFiles: data.fdipreFiles ? removeExpires(data.fdipreFiles) : [],
        courseDate: finishDate,
        trainerInstructorNumber: cdinstructorNumber,
        // CHNA-2766：选项 2 的候选人认证方法；选项 1 不传
        candidateMethod: fdi || owsi ? undefined : data.candidateMethod || undefined,
        prerequisiteOption: fdi || owsi ? 'option1' : 'option2',
        handwrittenSignatureUrl: getSubmitOssFormat(signatureUrl),
      }
      if (!ismember) submitData.regionId = regionId
      if (code) submitData.code = code
      submitAfdi(submitData).then((res) => {
        if (res.code) {
          let params = {
            code: res.code,
            paid: res.paid,
            paymentType: 'MEMBER_APPLICATION_AFDI',
          }
          if (isAutoRenewJump) {
            params.autoRenew = isAutoRenewJump
          }
          push('/application_submit_success?type=AFDI', params)
        }
      })
    } else {
      showModal(
        formatMessage({ id: 'dm-form-submit-error' }),
        formatMessage({ id: 'dm-form-submit-error-info' }),
        () => {},
        () => {},
        formatMessage({ id: 'common-comfirmBtn' }),
        formatMessage({ id: 'common-cancel' })
      )
    }
  }

  return (
    <ApplicantDetailStatus
      detail={detail}
      idType={'trainer'}
      submitFn={submit}
      payFn={toPay}
      applicationType={'AFDI'}
      payApplicationType={'MEMBER_APPLICATION_AFDI'}
      loading={submitting}
    />
  )
}

export default ApplicationStatus
